module.exports = __webpack_public_path__ + "static/media/7.4b8d228f.jpg";